import { type ResourceKeysStructure } from '../main';
import type defaultResources from './common.cs';

export default {
	'close.label': 'Close',
	'yes.label': 'Yes',
	'no.label': 'No',
	language: {
		label: 'Unknown',
		label_1: 'Czech',
		label_2: 'Slovak',
		label_3: 'English',
		label_4: 'German',
		label_5: 'French',
		label_6: 'Spanish',
		label_7: 'Russian',
		label_8: 'Norwegian',
		label_9: 'Swedish',
	},
	chipType: {
		label: 'Unknown',
		label_1: 'Regular chip',
		label_2: 'Online recharged chip',
		label_3: 'VIP chip',
		label_4: 'Anonymous transaction',
		label_5: 'Employee chip',
		label_6: 'Guest chip',
	},
	country: {
		label: 'Unknown',
		label_1: 'Czech Republic',
		label_2: 'Slovakia',
		label_3: 'Austria',
		label_4: 'United Kingdom of Great Britain and Northern Ireland',
		label_5: 'Serbia',
		label_6: 'Belgium',
		label_7: 'Bulgaria',
		label_8: 'Croatia',
		label_9: 'Cyprus',
		label_10: 'Denmark',
		label_11: 'Estonia',
		label_12: 'Finland',
		label_13: 'France',
		label_14: 'Germany',
		label_15: 'Greece',
		label_16: 'Hungary',
		label_17: 'Ireland',
		label_18: 'Italy',
		label_19: 'Latvia',
		label_20: 'Lithuania',
		label_21: 'Luxembourg',
		label_22: 'Malta',
		label_23: 'Poland',
		label_24: 'Portugal',
		label_25: 'Romania',
		label_26: 'Slovenia',
		label_27: 'Spain',
		label_28: 'Sweden',
		label_29: 'Netherlands',
		label_30: 'Iceland',
		label_31: 'Liechtenstein',
		label_32: 'Norway',
		label_33: 'Switzerland',
	},
	currency: {
		label: 'Unknown',
		label_1: 'Crown',
		label_2: 'Euro',
		label_3: 'Serbian dinar',
		label_4: 'British pound',
		label_5: 'Polish zloty',
	},
	reqProvider: {
		label: 'Unknown',
		label_1: 'Email',
		label_2: 'Facebook',
		label_3: 'Google',
		label_4: 'Apple',
	},
	eventCategory: {
		label: 'Unknown',
		label_1: 'Music',
		label_2: 'Gastro',
		label_3: 'Culture',
		label_4: 'Wine',
		label_5: 'Sports',
		label_6: 'Serial event',
		label_7: 'Festival',
		label_8: 'Children',
		label_9: 'Party',
		label_10: 'Theater',
		label_11: 'Concert',
		label_12: 'Beer',
	},
	eventKind: {
		label: 'Unknown',
		label_1: 'One-time event',
		label_2: 'Long-term operation',
	},
	eventSize: {
		label: 'Unknown',
		label_1: 'Small',
		label_2: 'Medium',
		label_3: 'Large',
	},
	eventType: {
		label: 'Unknown',
		label_1: 'Tickets',
		label_2: 'Packages',
		label_3: 'Credit recharge',
	},
	itemType: {
		label: 'Unknown',
		label_1: 'Event entry',
		label_2: 'Parking',
		label_3: 'NFC chip',
		label_4: 'Attraction entry',
		label_5: 'Workshop',
		label_6: 'Product',
		label_7: 'Repeated event entry',
		label_8: 'NFC chip VIP',
		label_9: 'Zone',
	},
	paymentMethod: {
		label: 'Unknown',
		label_1: 'Credit card',
		label_2: 'Bank transfer',
		label_3: 'Google Pay',
		label_4: 'Apple Pay',
		label_5: 'Mobile terminal',
		label_6: 'Cash',
		label_7: 'Chip',
		label_8: 'VIP chip',
		label_9: 'Tickets voucher',
		label_10: 'Partner',
		label_11: 'Click To Pay',
	},
	productCategory: {
		label: 'Unknown',
		label_1: 'Non-alcoholic',
		label_2: 'Beer',
		label_3: 'Wine',
		label_4: 'Other alcohol',
		label_5: 'Salty',
		label_6: 'Sweet',
		label_7: 'Supplementary assortment',
	},
	region: {
		label: 'Unknown',
		label_1: 'Prague',
		label_2: 'Central Bohemian Region',
		label_3: 'South Bohemian Region',
		label_4: 'Plzeň Region',
		label_5: 'Karlovy Vary Region',
		label_6: 'Ústí nad Labem Region',
		label_7: 'Liberec Region',
		label_8: 'Hradec Králové Region',
		label_9: 'Pardubice Region',
		label_10: 'Vysočina Region',
		label_11: 'South Moravian Region',
		label_12: 'Olomouc Region',
		label_13: 'Zlín Region',
		label_14: 'Moravian-Silesian Region',
		label_201: 'Bratislava Region',
		label_202: 'Trnava Region',
		label_203: 'Trenčín Region',
		label_204: 'Nitra Region',
		label_205: 'Žilina Region',
		label_206: 'Banská Bystrica Region',
		label_207: 'Prešov Region',
		label_208: 'Košice Region',
		label_301: 'Vienna',
		label_302: 'Lower Austria',
		label_303: 'Upper Austria',
		label_304: 'Styria',
		label_305: 'Carinthia',
		label_306: 'Burgenland',
		label_307: 'Salzburg',
		label_308: 'Tyrol',
		label_309: 'Vorarlberg',
		label_501: 'Vojvodina',
		label_502: 'Belgrade',
		label_503: 'Kosovo',
		label_504: 'Metohija',
		label_505: 'Šumadija and Western Serbia',
		label_506: 'Southern and Eastern Serbia',
		label_1501: 'Attica',
		label_1502: 'Central Greece',
		label_1503: 'Central Macedonia',
		label_1504: 'Crete',
		label_1505: 'Eastern Macedonia and Thrace',
		label_1506: 'Epirus',
		label_1507: 'Ionian Islands',
		label_1508: 'North Aegean',
		label_1509: 'Peloponnese',
		label_1510: 'South Aegean',
		label_1511: 'Thessaly',
		label_1512: 'Western Greece',
		label_1513: 'Western Macedonia',
		label_1401: 'Baden-Württemberg',
		label_1402: 'Bavaria',
		label_1403: 'Berlin',
		label_1404: 'Brandenburg',
		label_1405: 'Bremen',
		label_1406: 'Hamburg',
		label_1407: 'Hesse',
		label_1408: 'Lower Saxony',
		label_1409: 'Mecklenburg-Vorpommern',
		label_1410: 'North Rhine-Westphalia',
		label_1411: 'Rhineland-Palatinate',
		label_1412: 'Saarland',
		label_1413: 'Saxony',
		label_1414: 'Saxony-Anhalt',
		label_1415: 'Schleswig-Holstein',
		label_1416: 'Thuringia',
	},
	sectionType: {
		label: 'Unknown',
		label_1: 'Popular',
		label_2: 'Our selection',
		label_3: 'Happening now',
		label_4: 'This weekend',
		label_5: 'Just announced',
		label_6: 'Special',
		label_7: 'Near me',
	},
	venueType: {
		label: 'Unknown',
		label_1: 'Stadium',
		label_2: 'Camp',
		label_3: 'Meadow area',
		label_4: 'Outdoor theater/cinema',
		label_5: 'Theater/cinema',
		label_6: 'City',
		label_7: 'Music club',
	},
} as const satisfies ResourceKeysStructure<typeof defaultResources>;
